import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import store from "@/state/store";
import {
  getDomainByRoleId,
  isLocalhost,
  getRolePrefix,
} from "@/helpers/roleHelper";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("Router Before Each:");
  console.log("  To Name:", to.name);
  console.log("  From Name:", from.name);
  const authRequired = to.matched.some((record) => record.meta.authRequired);
  const loggedIn = store.getters["auth/isAuthenticated"];
  const userRoleId = store.getters["auth/currentRoleId"];
  const userRolePrefix = getRolePrefix(userRoleId);
  console.log("  Logged In:", loggedIn);
  console.log("  User Role ID:", userRoleId);
  console.log("  User Role Prefix:", userRolePrefix);

  if (authRequired && !loggedIn) {
    next({ name: "login" });
  } else if (loggedIn && to.name === "login") {
    // If the user is logged in and tries to access the login page, redirect to dashboard
    next({ name: `${userRolePrefix}-dashboard` });
  } else if (loggedIn && userRoleId) {
    const currentDomain = window.location.hostname;
    console.log("  Current Domain:", currentDomain);
    const requiredDomain = getDomainByRoleId(userRoleId);
    console.log("  Required Domain:", requiredDomain);

    // Skip domain validation for localhost/development
    if (isLocalhost()) {
      // Cegah akses prefix role lain
      if (to.params.rolePrefix && to.params.rolePrefix !== userRolePrefix) {
        // Redirect ke prefix yang benar (atau dashboard)
        // Ganti prefix di path
        const correctPath = to.fullPath.replace(
          /^\/(admin|staff|doctor)/,
          `/${userRolePrefix}`
        );
        next(correctPath);
        return;
      }

      // Check if route has allowedRoles and user has access
      if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(userRoleId)) {
        next({ name: "dashboard" });
        return;
      }
      next();
      return;
    }

    // Redirect to correct domain if user is on wrong domain
    if (requiredDomain && currentDomain !== requiredDomain) {
      const protocol = window.location.protocol;
      const port = window.location.port ? `:${window.location.port}` : "";
      const newUrl = `${protocol}//${requiredDomain}${port}/`; // Redirect to root path of correct domain
      console.log("  Redirecting to:", newUrl);
      window.location.href = newUrl;
      return;
    }

    // Cegah akses prefix role lain di production juga
    if (to.params.rolePrefix && to.params.rolePrefix !== userRolePrefix) {
      const correctPath = to.fullPath.replace(
        /^\/(admin|staff|doctor)/,
        `/${userRolePrefix}`
      );
      next(correctPath);
      return;
    }

    // Check if route has allowedRoles and user has access
    if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(userRoleId)) {
      next({ name: "dashboard" });
      return;
    }

    next();
  } else {
    next();
  }
});

export default router;
